export default __webpack_public_path__ + "static/ebusiness_lhsh-47bec79b7ee15350a9f88dfac89203ad.svg";